import React from "react";

// Descriptions are written in the admin's Quill editor and stored as HTML; html-content
// (index.css) restores the heading and list styles that Tailwind's preflight strips.
const HtmlContent = ({html, className = ""}) => (
    <div className={`html-content ${className}`} dangerouslySetInnerHTML={{__html : html}}></div>
);

export default HtmlContent;
